import { render, staticRenderFns } from "./SwitchPanel.vue?vue&type=template&id=9a824120&scoped=true&"
import script from "./SwitchPanel.vue?vue&type=script&lang=js&"
export * from "./SwitchPanel.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPanel.vue?vue&type=style&index=0&id=9a824120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a824120",
  null
  
)

export default component.exports